import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import NextActions from './components/NextActions';
import CoreTeam from './components/CoreTeam';
import FundraisingPhases from './components/FundraisingPhases';
import Deliverables from './components/Deliverables';
import Blueprint from './components/Blueprint';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white">
        <Header />
        <Routes>
          <Route path="/" element={
            <main>
              <Hero />
              <NextActions />
              <CoreTeam />
              <FundraisingPhases />
              <Deliverables />
              <Blueprint />
            </main>
          } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;